<script>
	import { t } from '$lib/translations';

	import YouTube from "$lib/images/social_media/youtube.svg"
	import Discord from "$lib/images/social_media/discord.svg"
	import TikTok from "$lib/images/social_media/tiktok.svg"
	import Telegram from "$lib/images/social_media/telegram.svg"
</script>

<div class="social-links">
	<a href="{$t('home.youtube_link')}" target="_blank"><div class="link">
		<div class="image">
			<img src={YouTube} alt="YouTube">
		</div>
		<div class="text">
			<div class="title">{$t('home.youtube')}</div>
			<div class="info"><span class="primary-text">{$t('home.youtube_info_followers')}</span> <span class="yellow">{$t('home.youtube_followers')}</span></div>
		</div>
	</div></a>
	<a href="{$t('home.discord_link')}" target="_blank"><div class="link">
		<div class="image">
			<img src={Discord} alt="Discord">
		</div>
		<div class="text">
			<div class="title">{$t('home.discord_title')}</div>
			<div class="info"><span class="primary-text">{$t('home.discord_info_members')}</span> <span class="yellow">{$t('home.discord_members')}</span></div>
		</div>
	</div></a>
	<a href="{$t('home.tiktok_link')}" target="_blank"><div class="link">
		<div class="image">
			<img src={TikTok} alt="TikTok">
		</div>
		<div class="text">
			<div class="title">{$t('home.tiktok_title')}</div>
			<div class="info"><span class="primary-text">{$t('home.tiktok_info_followers')}</span> <span class="yellow">{$t("home.tiktok_followers")}</span></div>
		</div>
	</div></a>
	<a href="{$t('home.telegram_link')}" target="_blank"><div class="link">
		<div class="image">
			<img src={Telegram} alt="Telegram">
		</div>
		<div class="text">
			<div class="title">{$t('home.telegram_title')}</div>
			<div class="info"><span class="primary-text">{$t('home.telegram_info_members')}</span> <span class="yellow">{$t('home.telegram_members')}</span></div>
		</div>
	</div></a>
</div>

<style lang="scss">
	@import "/src/lib/scss/main";

	.social-links {
		display: flex;
		gap: 36px;
		justify-content: center;
		margin-top: 20px;
		flex-wrap: wrap;
	}

	a {
		text-decoration: none;
	}

	.link {
		border-radius: 4px;
		width: 301px;
		height: 84px;
		background: #161616;
		padding: 18px;
		display: flex;
		align-items: center;
		gap: 16px;
		cursor: pointer;
		transition: background-color $default-transition-time;

		& > .image {
			width: 3rem;
			background: rgba(255, 251, 239, 0.1);
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 10px;
			border-radius: 6px;
			transition: background $default-transition-time;

		}
		& > .text {
			display: flex;
			flex-direction: column;
			gap: 4px;

			& > .title {
				font-size: 18px;
				color: white;
				transition: color $default-transition-time;
				font-weight: 600;
			}

			& > .info {
				font-size: 16px;
				line-height: 120%;
				color: #FFFBEF;
				transition: color $default-transition-time;

				& > .primary-text {
					opacity: 0.4;
					font-weight: 400;
				}

				& > .yellow {
					font-style: italic;
					color: #fed500;
					font-weight: 900;
					transition: color $default-transition-time;
				}
			}
		}

		&:hover {
			background-color: #fed500;

			& > .image {
				background: rgba(35, 35, 35, 0.1);
			}
			& > .text {

				& > .title {
					color: #232323;
				}
				& > .info {
					color: #232323;

					& > .yellow {
						color: #232323;
					}
				}
			}
		}
	}

	@media screen and (max-width: 700px) {
		.link {
			width: 320px!important;
		}
		.social-links {
			gap: 10px!important;
		}
	}

	@media screen and (max-width: 320px) {
		.link {
			width: 280px!important;
		}
	}
</style>